// Modules
import React, { useState } from "react"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"
import MoreVertIcon from "@mui/icons-material/MoreVert"
import { ButtonIcon } from "~styled/button"

export interface ListItemMenuProps {
  isActive: boolean
  onEdit: () => void
  onView: () => void
  onPreview: () => void
  onToggleStatus: () => void
  onDelete: () => void
  onMessagesView: () => void
  onPortfolioView: () => void
  onRedemptionsView: () => void
  onProofOfOwnershipView: () => void
}

const ListItemMenu = (props: Partial<ListItemMenuProps>) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const {
    isActive,
    onEdit,
    onView,
    onPreview,
    onToggleStatus,
    onDelete,
    onMessagesView,
    onPortfolioView,
    onRedemptionsView,
    onProofOfOwnershipView,
  } = props

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleEditClick = () => {
    if (!!onEdit) {
      onEdit()
    }
    handleClose()
  }

  const handleViewClick = () => {
    if (!!onView) {
      onView()
    }
    handleClose()
  }

  const handleToggleStatus = () => {
    if (!!onToggleStatus) {
      onToggleStatus()
    }
    handleClose()
  }

  const handleDeleteClick = () => {
    if (!!onDelete) {
      onDelete()
    }
    handleClose()
  }

  const handlePreviewClick = () => {
    if (!!onPreview) {
      onPreview()
    }
    handleClose()
  }

  const handleMessagesClick = () => {
    if (!!onMessagesView) {
      onMessagesView()
    }
    handleClose()
  }

  const handlePortfolioView = () => {
    if (!!onPortfolioView) {
      onPortfolioView()
    }
    handleClose()
  }

  const handleRedemptionsView = () => {
    if (!!onRedemptionsView) {
      onRedemptionsView()
    }
    handleClose()
  }

  const handeProofOfOwnershipView = () => {
    if (!!onProofOfOwnershipView) {
      onProofOfOwnershipView()
    }
    handleClose()
  }

  return (
    <>
      <ButtonIcon width={"25"} onClick={handleClick}>
        <MoreVertIcon />
      </ButtonIcon>

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {/* View Button */}
        {onView && <MenuItem onClick={handleViewClick}>View</MenuItem>}

        {/*AggregatedPortfolio Button*/}
        {onPortfolioView && (
          <MenuItem onClick={handlePortfolioView}>Portfolio</MenuItem>
        )}

        {/*Proof of Ownership Button*/}
        {onProofOfOwnershipView && (
          <MenuItem onClick={handeProofOfOwnershipView}>
            Proof of Ownership
          </MenuItem>
        )}

        {/* Preview Button */}
        {onPreview && <MenuItem onClick={handlePreviewClick}>Preview</MenuItem>}

        {onRedemptionsView && (
          <MenuItem onClick={handleRedemptionsView}>Redemptions</MenuItem>
        )}

        {/* Edit Button */}
        {onEdit && <MenuItem onClick={handleEditClick}>Edit</MenuItem>}

        {/* Messages Button */}
        {onMessagesView && (
          <MenuItem onClick={handleMessagesClick}>Messages</MenuItem>
        )}

        {/* Deactivate Button */}
        {onToggleStatus && (
          <MenuItem onClick={handleToggleStatus}>
            {isActive ? "Deactivate" : "Activate"}
          </MenuItem>
        )}

        {/* Delete Button */}
        {onDelete && isActive && (
          <MenuItem onClick={handleDeleteClick}>Delete user</MenuItem>
        )}
      </Menu>
    </>
  )
}

export default ListItemMenu
